const HeaderComponent = {
    templateUrl: '/header.tpl.html',
    controller: 'headerController',
    transclude: {
        leftSide: 'uiHeaderLeftSide',
        rightSide: 'uiHeaderRightSide'
    },
    bindings: {
        logoConfiguredFileName: '<',
        logoUrl: '<',
        menuItems: '<',
        showChatIcon: '<'
    }
};

angular.module('gw-um-header')
    .component('uiHeader', HeaderComponent);
